module.exports = __webpack_public_path__ + "static/media/loyalty_card.7677d54d.png";